import script from "./Form.vue?vue&type=script&setup=true&lang=ts"
export * from "./Form.vue?vue&type=script&setup=true&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=1fd0ce7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fd0ce7b"]])

export default __exports__